<form
  [formGroup]="form1"
  (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>Add {{this.tagLabel }}</h1>
  <mat-dialog-content> <mat-card> <mat-card-header> <mat-card-title></mat-card-title> </mat-card-header> <mat-card-content> Enter your tag below, then check your email for next steps.<br />
  <br />
  <mat-form-field> <input
    matInput
    maxlength="20"
    placeholder="Name"
    formControlName="name"
    required> @for (validation of validationMessages.name; track validation) {
    <mat-error> @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
      <mat-error
        class="error-message"
      > {{validation.message}}</mat-error>
    } </mat-error>
  } </mat-form-field> <mat-form-field> <mat-select
  placeholder="Visibility"
  [(value)]="form1.value.visibility"
  formControlName="visibility"
  required> @for ( vis of visibilities; track  vis) {
  <mat-option
  [value]="vis.value"> {{vis.name}} </mat-option>
} </mat-select> </mat-form-field>
<mat-form-field> <mat-select
  placeholder="Tag Category"
  formControlName="tagGroupCategoryPreset"> @for (cat of mergedCategoryOptions; track cat.value) {
  <mat-option
  [value]="cat.value"> {{cat.label}} </mat-option>
} </mat-select> </mat-form-field>
@if (isTagGroupCategoryOther()) {
  <mat-form-field> <input
    matInput
    maxlength="50"
    placeholder="Specify category"
    formControlName="tagGroupCategoryOther"
    required> </mat-form-field>
}
@if (form1.hasError('tagGroupCategoryOtherRequired') && form1.touched) {
  <mat-error class="error-message">Enter a category when Other is selected.</mat-error>
}
<p>TagType: {{tagType}}</p>
</mat-card-content> </mat-card> </mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
  type="submit">Submit</button>
  <button
    mat-button
    type="button"
  mat-dialog-close>Cancel</button>
</mat-dialog-actions>
</form>
